import React from 'react';
import CertificateInfoApp from './CertificateInfoApp';

const CertificateInfoEntry = () => {
  return <CertificateInfoApp />;
};

export default CertificateInfoEntry;
